<script setup lang="ts">
import { useSite } from "@/api/site-query";
import Frame from "@/components/common/Frame.vue";
import SettingsHeader from "@/components/common/SettingsHeader.vue";
import { icPlaceOutline } from "@/components/icons";
import SiteSelection from "@/components/map/object-selection/SiteSelection.vue";
import SiteTabs from "@/components/projects/SiteTabs.vue";
import CustomRouterView from "@/layouts/content/CustomRouterView.vue";
import Drawer from "@/layouts/drawer/Drawer.vue";
import DrawerLayout from "@/layouts/drawer/DrawerLayout.vue";
import { DrawerSelection } from "@/layouts/drawer/use-drawer-data";
import { useDrawerStore } from "@/stores";
import { useScreenSize } from "@soft-db/ui";

const route = useRoute();
const id = computed(() => route.params.id as string);
const { site } = useSite(id);

const { mdOrLower } = useScreenSize();
const { toggleDrawer } = useDrawerStore();

const router = useRouter();
function changePage(selection: DrawerSelection) {
	router.push({
		name: "sites-id-settings",
		params: { id: selection.id },
		query: { ...route.query },
	});
	if (mdOrLower.value) toggleDrawer();
}
</script>

<template>
	<DrawerLayout>
		<template #drawer>
			<Drawer :objects="['site']" @click="changePage" />
		</template>
		<div class="h-full overflow-auto">
			<SettingsHeader :icon="icPlaceOutline" :name="site?.name" sourceType="site" :sourceId="id">
				<SiteSelection v-if="site" :site="site" />
			</SettingsHeader>
			<Frame>
				<SiteTabs />
				<CustomRouterView />
			</Frame>
		</div>
	</DrawerLayout>
</template>
